import React, { Component } from 'react';
import { Modal, Timeline } from 'antd';
import moment from 'moment';

import { queryContractLog } from '@api/xxcrm/contract';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      log: [],
    };
  }

  componentDidMount() {
    this.loadLog(this.props.contractUuid);
  }

  loadLog = uuid => {
    queryContractLog(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          log: res.data,
        });
      }
    });
  };

  render() {
    const { cancel } = this.props;
    const { log } = this.state;
    return (
      <Modal
        title="发票操作记录"
        width={400}
        visible
        onCancel={cancel}
        footer={false}
        maskClosable={false}
      >
        {log.length > 0 ? (
          <Timeline>
            {log.map(item => {
              return (
                <Timeline.Item key={item.uuid}>
                  {moment.unix(item.cdate / 1000).format('YYYY-MM-DD H:mm:ss')} {item.operator}{' '}
                  {item.action}
                </Timeline.Item>
              );
            })}
          </Timeline>
        ) : (
          <p style={{ textAlign: 'center', lineHeight: '30px' }}>暂无操作记录</p>
        )}
      </Modal>
    );
  }
}
export default Index;



// WEBPACK FOOTER //
// ./src/components/xianxing/invoice/ModalRecord.js